import salaTarasowa from "src/assets/img/studio/sala-tarasowa.webp";

export default function Wypozyczalnia() {
  return (
    <main className="wypozyczalnia">
      <section className="wypozyczalnia__main main">
        <div className="main__container">
          <div className="main__image-block">
            <img src={salaTarasowa} alt="Sala Balowa"></img>
            <h1 className="main__title">Wypożyczalnia</h1>
          </div>
        </div>
      </section>
      <section className="wypozyczalnia__sprzent sprzent">
        <div className="sprzent__container">
          <div className="sprzent__header">
            <h3 className="sprzent__title">
              Profesjonalny sprzęt dla wszystkich potrzeb!
            </h3>
            <div className="sprzent__text">
              <p>
                Nasze studio fotograficzne zostało zaprojektowane z myślą o
                pełnej satysfakcji i wygodzie naszych klientów. Oferujemy nie
                tylko przestrzeń do pracy, ale także dostęp do wysokiej jakości
                sprzętu, który umożliwia realizację każdego projektu
                fotograficznego.
              </p>
              <p>
                W naszym studiu znajdziesz niezbędne wyposażenie fotograficzne,
                a jeśli czegoś będzie dla Ciebie za mało, chętnie dostarczymy
                dodatkowy sprzęt bezpośrednio na sesję zdjęciową. Wystarczy, że
                poinformujesz nas o tym podczas wykonywania rezerwacji.
              </p>
            </div>
          </div>
          <div className="sprzent__content">
            <h3 className="sprzent__title">Wyposażenie:</h3>
            <div className="sprzent__list list-sprzent">
              <div className="list-sprzent__item">
                <p>Wyzwalacz Godox X2 PRO Canon, Nikon, Fuji, Sony – 10 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa Godox AD600 PRO (z adapterem AC) – 3 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampar Godox AG1200PRO (z adapterem AC) – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa Godox QT400III M – 3 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa Godox QT 600IIIM – 3 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa Godox DP800III-V – 2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa Godox DP600III-V – 4 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa LED Nanlite FS 300B – 3szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa LED Nanlite FC 500B – 2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa LED Godox SL 150 – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa LED Quadralite VideoLED 1000 – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Lampa LED Quadralite VideoLED 600 – 2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>
                  Softbox 16-kątny głęboki 120 cm (z doczepianym gridem) – 1szt.
                </p>
              </div>
              <div className="list-sprzent__item">
                <p>
                  Softbox 16-kątny głęboki – 90 cm (z doczepianym gridem) –
                  1szt.
                </p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox 8-kątny 120 cm (z doczepianym gridem) – 2szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox 8-kątny 160 cm (z doczepianym gridem) – 1szt</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox 8-kątny 180 cm (z doczepianym gridem) – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox prostokątny 60 x 40 cm – 4szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox strip prostokątny 25 x 90 cm – 2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox strip prostokątny 35 x 140 cm – 4 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Softbox strip prostokątny 40 x 180 cm –2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Monitor graficzny do tetheringu Eizo 27” – 3 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Tło kartonowe jednobarwne 2,7 x 11 m – 10 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Parasol z dyfuzorem – 180 cm</p>
              </div>
              <div className="list-sprzent__item">
                <p>Beatuty dish 70 cm z gridem i dyfuzorem biały – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Beatuty dish 70 cm z gridem i dyfuzorem srebrny – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Czasza średnica 17 cm – 20 szt</p>
              </div>
              <div className="list-sprzent__item">
                <p>Fresnel Nanlite z wrotami – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Fresnel Bowens Fresnel 200 – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Beauty dish Bowens 60 cm z dyfuzorem wafer – 1szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Plastry miodu do czaszy 17 cm – 8 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>
                  Nakładka projekcyjna z obiektywem 150 mm i nakładkami Gobo – 1
                  szt.
                </p>
              </div>
              <div className="list-sprzent__item">
                <p>Folia translum – 120 x 700 cm – 2 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Tkanina dyfuzyjna na ramie 110 x 110 cm – 2szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Butterfly na ramie – 150 x 200 cm – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Butterflu Skylite Manfrotto 200 x 200 cm – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw c-stand – 12 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw oświetleniowy – 20 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw winda Wind-up 3,8 m – 2szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw typu boom na kółkach – 3 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw Autopole 3,7 m – 4 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw kolumnowy Manfrotto Mini Salon – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Statyw kolumnowy Foba Asaba – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Slider Edelkrone z napędem elektrycznym – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>Głowica Śledząca Edelkrone – 1 szt.</p>
              </div>
              <div className="list-sprzent__item">
                <p>
                  Tło canvas – ręcznie malowane na płótnie 2,2 x 5 m – 6 szt.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
